module.exports = __webpack_public_path__ + "img/horizontal_3_2_3016.adf7b69a.png";